<template>
  <b-card title="تسویه موجودی درگاه بین المللی">
    <b-row>
      <b-col>
        <b-form-group label="شماره حساب/ شبا">
          <div class="form-control">
            {{ data.shaba_number }}
          </div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="نام صاحب حساب">
          <div class="form-control">
            {{ data.nickname }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="وبسایت">
          <div class="form-control">
            {{ data.website_name }} ({{ data.website }})
          </div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="مبلغ تسویه (دلار)">
          <div class="form-control">
            {{ Number(data.bes).toLocaleString() }} $
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="مبلغ ارز">
          <div class="form-control">
            {{ Number(exchange.value).toLocaleString() }}
          </div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="مبلغ تسویه (ریال)">
          <div class="form-control">
            {{ Number(data.bes * exchange.value).toLocaleString() }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="کد رهگیری پرداخت">
          <b-form-input
            :disabled="data.rial_price"
            v-model="data.trackingNumber"
            placeholder="کد رهگیری پرداخت"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col> </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" :disabled="data.rial_price" @click="Save()"
          >ذخیره</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "paynationalprq",
  data() {
    return {
      data: {},
      exchange: {
        value: 0,
      },
    };
  },
  mounted() {
    httpHelper
      .getData("wallerpaymentrequested?id=" + this.$route.params.id)
      .then((res) => {
        this.data = res.result;
        if (!this.data.rial_price) {
          httpHelper.getData("exchange").then((res) => {
            this.exchange = res.result.find((o) => {
              return (
                o.international_gateway.code.toLowerCase() ==
                this.data.gateway_type
              );
            });
          });
        } else {
          this.exchange.value = this.data.rial_price / this.data.bes;
        }
      });
  },
  methods: {
    Save() {
      if (this.data.rial_price) {
        return;
      }
      httpHelper.postData("wallerpaymentrequested", this.data).then((res) => {
        this.$router.push("/wallet_payment_request");
      });
    },
  },
};
</script>